// extracted by mini-css-extract-plugin
export default {"b-icon-warning":"ExitButton_style_b-icon-warning__nESxu","exit-button-data-check":"ExitButton_style_exit-button-data-check__VGqpQ","rotate":"ExitButton_style_rotate__t3UZo"};